export const VehicleOwnership = [
    {
        label: 'Select',
        value: '',
    },
    {
        label: 'Short Term Rental',
        value: 'short_term_rental',
    },
    {
        label: 'Lease',
        value: 'lease',
    },
    {
        label: 'Own',
        value: 'own',
    },
    {
        label: 'Other',
        value: 'other',
    },
];
